import { Component, inject } from '@angular/core';
import { ErrorDialogFacade } from 'src/app/_core/state/dialogs/error/error.facade';
import { EditingFacade } from 'src/app/_core/state/dialogs/editing/editing.facade';
import { HelpButtonDialogFacade } from 'src/app/_core/state/dialogs/help-button/help-button.facade';
import { AmautasSubscriptionDialogFacade } from 'src/app/_core/state/dialogs/amautas-subscription/amautas-subscription.facade';
import { ConfirmationDialogFacade } from 'src/app/_core/state/dialogs/confirmation-dialog/confirmation-dialog.facade';

@Component({
  selector: 'app-modal-handler',
  templateUrl: './modal-handler.component.html',
})
export class ModalHandlerComponent {

  readonly editingFacade = inject(EditingFacade);
  readonly errorDialogFacade = inject(ErrorDialogFacade);
  readonly helpButtonFacade = inject(HelpButtonDialogFacade);
  readonly amautasSubscriptionDialogFacade = inject(AmautasSubscriptionDialogFacade);
  readonly confirmationDialogFacade = inject(ConfirmationDialogFacade);
}